import { maxTime } from 'date-fns';

export const defaults = {
	container: undefined,

	date: new Date(),
	minDate: new Date(),
	maxDate: new Date(maxTime),

	modifiers: {},
	disabled: undefined,
	selected: undefined,

	weekStartsOn: 0,
	numberOfMonths: 1,
	fixedWeeks: false,
	pagedNavigation: false,
	showOutsideDays: false,
	dir: 'ltr',
};

export const classes = {
	root: 'datepicker',
	months: 'datepicker-months',
	month: 'datepicker-month',
	week: 'datepicker-week',
	day: 'datepicker-day',
	dayButton: 'datepicker-day-button',
	dayName: 'datepicker-day-name',
	header: 'datepicker-header',
	prev: 'datepicker-prev',
	next: 'datepicker-next',
};
